(function (angular) {
    angular.module('bizPartEngage').service('core.session.service', sessionService);

    sessionService.$inject = ["$mdDialog", "$interval", "core.users.service", "$q", "$translate"];

    function sessionService($mdDialog, $interval, userService, $q, $translate) {
        this.SessionTime; 
        this.SessionTimeEnd; 
        this.ShowingWarning; 
        this.Timer;

        this.Initialize = function(time) {
            this.SessionTime = time;
            this.ShowingWarning = false;
            this.Refresh();
            localStorage.setItem('BIZEXTPAGE_SESSION_TIMEOUT', time);
        };

        this.Start = function() {
            Timer = $interval(Tick, 5000, 0, false, this);
        };

        this.Stop = function() {
            $interval.cancel(Timer);
        };

        this.Refresh = function(updateBackend) {
            this.SessionTimeEnd = moment().add(this.SessionTime, 's');

            if(updateBackend) {
                userService.UpdateUserSession().then(function() {
                    console.log('Session timer refreshed!');
                });
            }
        };

        this.TimeToShowWarning = function() {
            return moment().add(1, 'm') > this.SessionTimeEnd;
        };

        this.TimeOut = function() {
            return moment() > this.SessionTimeEnd;
        };

        function Tick(sessionTimer) {
            if (sessionTimer.TimeToShowWarning()) {
                if (sessionTimer.ShowingWarning == false) {
                    $mdDialog.show($mdDialog.alert({
                        title: $translate.instant("CORE.Session.Warning.Title"),
                        textContent: $translate.instant("CORE.Session.Warning.Content"),
                        ok: "Ok"
                    })).then(function() {
                        sessionTimer.Refresh(true);
                        sessionTimer.ShowingWarning = false;
                    });
        
                    sessionTimer.ShowingWarning = true;
                }
        
                if (sessionTimer.TimeOut()) {
                    sessionTimer.Stop();        
                    userService.Logout();
                }
            }
        }
    }
})(window.angular);
